<template>
  <h3 class="pb5">Rapport statistique sommaire de vigilance (CDX_0235)</h3>
  <CritereRechercheComiteDeVigilance ref="critereRechercheComiteDeVigilance"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheComiteDeVigilance from "@/components/rapports/Rechercher/CritereRechercheComiteDeVigilance.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "StatistiqueVigilanceSommaire",
  components: {CritereRechercheComiteDeVigilance, ButtonBar},
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Comité de vigilance");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$store.dispatch("narration/rechercherDefaut48HeuresAction")
        .then((res) => {
          this.assignerResultat(res);
        });
  },
  methods: {
    assignerResultat(res) {
      if (res.data.entites !== null)
        this.$refs.critereRechercheComiteDeVigilance.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      let criteresRecherche = this.$refs.critereRechercheComiteDeVigilance.getCriteresRecherche();
      criteresRecherche.titre = "StatistiqueVigilanceSommaire";
      criteresRecherche.nomRapport = "vigilance.StatistiqueVigilanceSommaireGenerateurRapport_CDX_0235";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    },
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },

}
</script>

<style scoped>

</style>